import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import { api, queryBuilder } from "../../services";
import { TMethod, TParams } from "../../services/types";

interface IPostOptions {
  method: TMethod;
  url: string;
  data: any;
  params?: TParams | undefined;
  config?: AxiosRequestConfig;
}
interface IPostProps {
  onSuccess?: (data: object) => unknown;
  onError?: (error: object) => unknown;
}

export function postData(options: IPostOptions) {
  const { method = "post", url, data, params, config } = options;
  return api[method](queryBuilder(url, params), data, {
    timeout: 30000,
    ...config,
  });
}

const usePost = ({ onSuccess, onError, ...params }: IPostProps = {}) => {
  return useMutation({
    mutationFn: postData,
    onSuccess: onSuccess,
    onError: onError,
    ...params,
  });
};

export default usePost;
